import { useNavigate } from "react-router-dom"
import { useAuthStore } from "../state/authStore"
import { logout } from "../api/auth"

export default function AdminDashboardPage() {
  const navigate = useNavigate()
  const ime = useAuthStore(s => s.ime)
  const token = useAuthStore(s => s.token)
  const clear = useAuthStore(s => s.clear)

  const handleLogout = async () => {
    if (token) await logout(token).catch(() => {})
    clear()
    navigate("/admin/login", { replace: true })
  }

  return (
    <div className="flex-1 flex flex-col">
      <header className="bg-primary-900 text-white px-4 py-3 flex items-center justify-between">
        <div className="font-semibold">SADEO Waiter Admin · {ime}</div>
        <button onClick={handleLogout} className="bg-primary-700 hover:bg-primary-600 px-3 py-1.5 rounded text-sm">Odjava</button>
      </header>
      <div className="flex-1 p-6 max-w-4xl mx-auto w-full">
        <h1 className="text-2xl font-bold text-slate-800 mb-6">Admin Dashboard</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-6">
            <h3 className="font-semibold text-slate-800 mb-2">Konobari</h3>
            <p className="text-slate-500 text-sm mb-4">Upravljaj konobarima, resetuj PIN-ove.</p>
            <button className="bg-slate-200 text-slate-500 px-4 py-2 rounded text-sm cursor-not-allowed" disabled>Uskoro</button>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-6">
            <h3 className="font-semibold text-slate-800 mb-2">Tableti</h3>
            <p className="text-slate-500 text-sm mb-4">Generiši setup ključeve, deaktiviraj uređaje.</p>
            <button className="bg-slate-200 text-slate-500 px-4 py-2 rounded text-sm cursor-not-allowed" disabled>Uskoro</button>
          </div>
        </div>
        <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm text-yellow-800">
          <strong>Napomena:</strong> Admin funkcionalnosti dolaze u sljedećoj verziji.
        </div>
      </div>
    </div>
  )
}
